/* Program Name: Footer.js
 **  Description: component for the footer of the application
 **
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-03-17  STT  Initial program
 *********************************************************************************/

/**React imports */
import React from 'react'

/**Footer *********************************************************************/
const Footer = () => {
  /****************************************************************************/
  /**LocalVariables */

  /*****************************************************************************/
  /**Rendering */

  return (
    <div
      style={{
        fontSize: 9,
        textAlign: 'center',
        position: 'absolute',
        bottom: 0,
      }}
    >
      All Rights Reserved Serigraph &copy;
    </div>
  )
}

export default Footer
